/* global Stripe */
import React from 'react';
import { render } from 'react-dom';
import Root from './root';
import config from './config';
import './flags'; // initialize flags client

// support stripe v2
// for newer functionality use /utils/stripe.js
function setStripeKey() {
  Stripe.setPublishableKey(config.stripeKey);
}

setStripeKey();

render(<Root />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.jsx